import React from 'react';

import Toggle from 'components/Toggle';

import { Container, Item, PaymentCardIcon } from './styles';

export interface SwitchItemProps {
  title?: string;
  subtitle?: string;
  icon?: string;
  onToggle: (value) => void;
  value?: boolean;
}

const SwitchItem = ({ title, subtitle, icon, onToggle, value }: SwitchItemProps) => (
  <Container>
    <Item>
      <Item.Title>{title}</Item.Title>
      <Item.Card>
        {icon ? <Item.Icon src={icon} alt="" /> : <PaymentCardIcon />}
        {subtitle}
      </Item.Card>
    </Item>
    <Item.Switch>
      <Toggle onChange={onToggle} checked={value ? true : false} />
    </Item.Switch>
  </Container>
);

export default SwitchItem;
